import { createInertiaApp, router } from "@inertiajs/react"
import { createRoot } from "react-dom/client"
import { I18nProvider, type Locale } from "@/lib/i18n"
import { initSentry, Sentry } from "@/lib/sentry"
import ErrorFallback from "@/components/ErrorFallback"
import "../css/application.css"

initSentry()

// Keep the csrf-token meta tag in sync with Inertia shared props after every
// SPA navigation.  This prevents stale tokens after session changes (sign-out → sign-in).
router.on("navigate", () => {
  const token = (router.page?.props as Record<string, unknown>)?.csrf_token
  if (typeof token === "string" && token) {
    document
      .querySelector('meta[name="csrf-token"]')
      ?.setAttribute("content", token)
  }
})

const pages = import.meta.glob("../pages/**/*.tsx")

createInertiaApp({
  resolve: (name) => {
    const page = pages[`../pages/${name}.tsx`]
    if (!page) {
      throw new Error(`Page not found: ${name}`)
    }
    return page()
  },
  setup({ el, App, props }) {
    const currentUser = (props.initialPage.props as Record<string, any>)?.current_user
    const serverLocale = currentUser?.locale as Locale | undefined

    createRoot(el).render(
      <I18nProvider initialLocale={serverLocale}>
        <Sentry.ErrorBoundary fallback={<ErrorFallback />}>
          <App {...props} />
        </Sentry.ErrorBoundary>
      </I18nProvider>
    )
  },
})
